import { DateTime } from "luxon";
import { useContext, useEffect, useMemo } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { AuthContext } from "../Auth/AuthContext";
import { useFlags } from "launchdarkly-react-client-sdk";

interface ContextType {
  customerName: string;
}

const useDisplayEOY = () => {
  const { push } = useHistory();

  let match = useRouteMatch<{ item: string }>("/:item");
  const eoyLSFlag = "show-eoy";
  const eoyPath = "yearly-report";

  const {
    authState: { context, username },
  } = useContext(AuthContext);

  const { showEndOfYear, hideEoyFromUser } = useFlags();

  const eoyCustomerLSFlag = useMemo(
    () => `${eoyLSFlag}-${(context as unknown as ContextType)?.customerName}`,
    [context]
  );

  const allowEndOfYear = useMemo(() => {
    const today = DateTime.local().startOf("day"); // Get today's date, ignoring the time
    const startDate = DateTime.fromISO("2025-11-01");
    const endDate = DateTime.fromISO("2026-01-15");

    return showEndOfYear && today >= startDate && today <= endDate;
  }, [showEndOfYear]);

  useEffect(() => {
    const isSeen = !!localStorage.getItem(eoyCustomerLSFlag);
    const isHidden = hideEoyFromUser?.includes(btoa(username ?? ""));
    if (
      !isHidden &&
      allowEndOfYear &&
      !isSeen &&
      match?.params?.item !== eoyPath
    ) {
      openEndOfYear();
    }
  }, [match, allowEndOfYear, eoyCustomerLSFlag, username, hideEoyFromUser]);

  const openEndOfYear = () => {
    push(`/${eoyPath}`);
    localStorage.setItem(eoyCustomerLSFlag, "seen");
  };

  const shouldDisplayEOY = useMemo(
    () => match?.params?.item === eoyPath,
    [match?.params?.item]
  );

  return {
    shouldDisplayEOY,
    openEndOfYear,
    allowEndOfYear,
    eoyPath,
  };
};

export default useDisplayEOY;
